module.exports = __webpack_public_path__ + "static/img/6-5.d20c221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6-5.png
// module id = yBpr
// module chunks = 1